
import ColorTemperatureSwatch from '@/components/ColorTemperatureSwatch.vue'
import ProductTechnicalFilterSlider from '@/components/ProductTechnicalFilterSlider.vue'
import { colorTemperatureToneRanges } from '@/utils/colorTemperature'
import { formatTechnicalValue, snapToStep } from '@/utils/technicalFilters'

export default {
  name: 'ProductTechnicalFilterRange',
  components: { ColorTemperatureSwatch, ProductTechnicalFilterSlider },
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      range: [...this.filter.value],
      touched: false,
    }
  },
  computed: {
    isColorTemperature() {
      return this.filter.key === 'color_temperature'
    },
    hasSelection() {
      return this.filter.active || this.touched
    },
    sliderValue() {
      return this.range.map(number =>
        snapToStep(number, this.filter.bounds, this.filter.step)
      )
    },
    tones() {
      if (!this.isColorTemperature) return []

      return colorTemperatureToneRanges(this.filter.bounds, this.filter.values)
    },
  },
  watch: {
    'filter.value'(value) {
      this.range = [...value]
      this.touched = false
    },
  },
  methods: {
    focusSlider() {
      const dot = this.$el.querySelector('.vue-slider-dot')
      if (dot) dot.focus()
    },
    update(value) {
      if (value.every((number, index) => number === this.range[index])) return
      if (value.every((number, index) => number === this.sliderValue[index])) {
        return
      }

      this.range = [...value]
      this.touched = true
      this.$emit('change', this.filter, this.range)
    },
    reset() {
      this.focusSlider()
      this.$emit('reset', this.filter)
    },
    format(value) {
      return formatTechnicalValue(value, this.filter, this.$i18n.locale)
    },
    isSelected(tone) {
      return (
        (this.filter.active || this.touched) &&
        this.range[0] === tone.from &&
        this.range[1] === tone.to
      )
    },
  },
}
